module.exports = __webpack_public_path__ + "41fb07c386021d699a5589bf558ac913.png";